import axios from 'axios';
import type { IUserFindLinkedResponse } from '@/app-package';

export const getLinkedAccounts = async (email: string) =>
  axios.get<IUserFindLinkedResponse>(`user/linked?email=${email}`);
